window.addEventListener('load', function () {
    /* ===== Hides Document Upload When No Radio Button Selected and Show When Yes Selected ===== */

    // vars -- nth-of-type(1) = "Yes" radio button ||  nth-of-type(2) = "No" radio button
    let showUploads = document.querySelectorAll('.allow-upload div:nth-of-type(1) label input');
    let hideUploads = document.querySelectorAll('.allow-upload div:nth-of-type(2) label input');

    // Show option to upload file when "yes" is checked
    showUploads.forEach(function (showUpload) {
        showUpload.addEventListener('click', function () {
            showUpload.closest('section').nextSibling.nextSibling.classList.add('display-upload');
        });
    });

    // Hide option to upload file when "no" is checked
    hideUploads.forEach(function (hideUpload) {
        hideUpload.addEventListener('click', function () {
            hideUpload
                .closest('section')
                .nextSibling.nextSibling.classList.remove('display-upload');
        });
    });

    /* ========= Show Corresponding Field When Specific Dropdown Option is Chosen ============= */

    // Disable all hidden fields so they don't come back in submitted response
    let ddModels = document.querySelectorAll('.dd-model');
    ddModels.forEach(function (ddModel) {
        ddModel.lastChild.previousSibling.disabled = true;
    });

    let dynamicDDs = document.querySelectorAll('.dynamic-dd select');
    dynamicDDs.forEach(function (dynamicDD) {
        dynamicDD.onchange = function () {
            // vars
            let section = dynamicDD.closest('section');
            let currentSelected = section.querySelector('.dd-model-active');
            // Hide and Disable any Previous Selected Dropdowns
            if (currentSelected) {
                currentSelected.classList.remove('dd-model-active');
                currentSelected.lastChild.previousSibling.disabled = true;
            }
            // Show and Able Currently Selected Dropdown
            let selected = section.querySelector('.model-' + dynamicDD.options.selectedIndex);
            selected.classList.add('dd-model-active');
            selected.lastChild.previousSibling.disabled = false;
        };
    });
});
